import api from "./api";

export async function subscribePush() {
  try {
    if (!("Notification" in window) || !("serviceWorker" in navigator)) return;
    const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
    if (!apiKey || !vapidKey) return;
    if (Notification.permission === "denied") return;
    const perm = await Notification.requestPermission();
    if (perm !== "granted") return;
    const { initializeApp, getApps } = await import("firebase/app");
    const { getMessaging, getToken } = await import("firebase/messaging");
    const app = getApps()[0] || initializeApp({
      apiKey,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
    });
    const reg = await navigator.serviceWorker.ready;
    const token = await getToken(getMessaging(app), { vapidKey, serviceWorkerRegistration: reg });
    if (token) await api.post("/push/subscribe", { token, platform: "web" });
  } catch (e) {
    // push bersifat opsional — abaikan kegagalan agar tidak mengganggu aplikasi
  }
}
